<script setup lang="ts">
import type { IFeatureItem } from '../../../models'
import ListItem from './FeatureSecondaryListItem.component.vue'

const items: IFeatureItem[] = (useAttrs().items || ([] as any)).filter((x: IFeatureItem) => !x.exclude)
</script>

<template>
  <div
    class="mx-auto grid max-w-2xl grid-cols-1 gap-8 text-base leading-7 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:gap-x-16"
  >
    <ListItem v-for="item of items" :key="item.key" :model="item"></ListItem>
  </div>
</template>
